module.exports = __webpack_public_path__ + "img/kayak002.148629b9.jpg";